export interface ConnectFlowAudioFormState {
    name: string | null;
    audioFilePath: string | null;
    isActive: boolean;
}
